module.exports = __webpack_public_path__ + "static/lululemon-logo-caa96eff3da4fe998a2337312fd9065e.png";